import { Chip, ChipProps } from 'react-native-paper';

import Text from './Text';

interface BrandedChipProps extends Omit<ChipProps, 'children'> {
  isSelected: boolean;
  value: string;
  fontSize?: number;
  borderRadius?: number;
}

const BrandedChip = ({ isSelected, value, fontSize, borderRadius, ...props }: BrandedChipProps) => {
  return (
    <Chip
      {...props}
      mode="outlined"
      textStyle={{ flex: 1 }}
      selected={isSelected}
      style={{
        height: 35,
        backgroundColor: isSelected ? 'black' : 'white',
        borderRadius: borderRadius ?? 20,
        flex: 1
      }}
      maxFontSizeMultiplier={1}
      showSelectedCheck={false}>
      <Text
        fontWeight="500"
        style={{
          color: isSelected ? 'white' : 'black',
          textAlign: 'center',
          fontSize: fontSize ?? 16
        }}>
        {value}
      </Text>
    </Chip>
  );
};

export default BrandedChip;
